module.exports = __webpack_public_path__ + "img/consult_info7.c96587b6.png";